module.exports = __webpack_public_path__ + "img/braga-logo-icon.fdad978b.png";